import { State } from '@/store/index';
import { Module } from 'vuex';
import {
  HallApi,
  HallApiHallsSuitableGetCollectionRequest,
  HallRead,
} from '@/api';
import axios from 'axios';
import helpers from '../services/helpers';

function getFunctionSpaceApi(): HallApi {
  return new HallApi(undefined, import.meta.env.VITE_PROXY_URL, axios);
}

const getDefaultState = () => ({
  allSpaces: [] as Array<HallRead>,
});

export type functionSpaceState = ReturnType<typeof getDefaultState>;

export const FunctionSpaces: Module<functionSpaceState, State> = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setSpaces(state, response: Array<HallRead>) {
      state.allSpaces = response;
    },
  },

  actions: {
    async fetchAllSpaces({ commit }, locationId: number) {
      const api = getFunctionSpaceApi();
      const response = await api.hallsGetCollection({
        location: `/api/locations/${locationId}`,
        available: true,
      });

      commit('setSpaces', response.data['hydra:member']);
    },

    async fetchSuitableSpaces(
      _,
      {
        locationId,
        settings,
      }: {
        locationId: number;
        settings: HallApiHallsSuitableGetCollectionRequest;
      },
    ) {
      const api = getFunctionSpaceApi();
      const response = await api.hallsSuitableGetCollection({
        location: `/api/locations/${locationId}`,
        emplacement: helpers.getIRI(settings.emplacement, '/api/emplacements/'),
        startTime: settings.startTime ?? undefined,
        endTime: settings.endTime ?? undefined,
        pax: settings.pax ?? undefined,
        available: true,
        date: settings.date ?? undefined,
      });

      return response.data['hydra:member'];
    },
  },
};
